import React, { CSSProperties } from 'react';
import { COLORS } from '../constants/styles';

interface IProps {
  style?: CSSProperties;
  fill?: string;

  [prop: string]: unknown;
}

export default ({ style, fill = COLORS.black, ...rest }: IProps) => {
  const defaultStyle = { width: 18, height: 18 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height} {...rest} viewBox="0 0 18 18" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M9 7.69612L1.46802 0L7.75726e-06 1.5L7.53199 9.19612L0.383875 16.5L1.85188 18L9 10.6961L16.1481 18L17.6161 16.5L10.468 9.19612L18 1.5L16.532 0L9 7.69612Z" fill={fill}/>
    </svg>
  );
};
